import QRCode from 'qrcode';
import React from 'react';

import { ActionSheet } from '../Activity/ActionSheet';
import styles from './index.module.scss';

const showWxQrCode = async (props?: {
  onShow?: () => void;
  onHide?: () => void;
  scanUrl?: string;
}) => {
  const { onShow, onHide, scanUrl } = props || {};
  const url = scanUrl || window.location.href;
  const qrCodeImg = await QRCode.toDataURL(url, {
    margin: 1,
    width: 174,
    type: 'image/jpeg',
    errorCorrectionLevel: 'L'
  });

  const domKey = ActionSheet.showInstance(
    <div className={styles.mask}>
      <div className={styles.content}>
        <div className={styles.tip}>请使用微信扫描下方二维码</div>
        <div className={styles.tip}>登录当前账号分享</div>
        <img src={qrCodeImg} className={styles.qrCode} />
        <span
          className={styles.close}
          onClick={() => {
            if (typeof onHide === 'function') {
              onHide();
            }
            ActionSheet.removeInstance(domKey);
          }}
        />
      </div>
    </div>
  );
  if (typeof onShow === 'function') {
    onShow();
  }
};

export default showWxQrCode;
